/* Sparq Wear — sepete ekleme yardımcısı (paket, "birlikte al", sepet önerileri).
   Horizon'un standart sepet olayını yayınlar; böylece sepet çekmecesi ve sepet simgesi kendiliğinden yenilenir. */
import { CartLinesUpdateEvent } from '@shopify/events';

const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

const openDrawer = () => {
  const drawer = document.getElementById('cart-drawer');
  if (drawer && typeof drawer.open === 'function') {
    if (!drawer.isOpen) drawer.open();
    return true;
  }
  return false;
};

/**
 * @param {{id: number|string, quantity: number}[]} items
 * @param {{open?: boolean}} [opts]
 */
const add = async (items, opts = {}) => {
  const lines = items.filter((i) => i && i.id && i.quantity > 0);
  if (!lines.length) return null;
  const { promise, resolve, reject } = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: lines.map((l) => ({ merchandiseId: String(l.id), quantity: Number(l.quantity) })),
      promise,
    })
  );
  try {
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines.map((l) => ({ id: Number(l.id), quantity: Number(l.quantity) })) }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'error');
    const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'sparqwear' } });
    if (opts.open !== false) setTimeout(openDrawer, 60);
    return cart;
  } catch (err) {
    reject(err);
    throw err;
  }
};

window.SparqCart = { add, open: openDrawer };
document.dispatchEvent(new CustomEvent('sparqcart:ready'));

/* Sepet önerileri ve "birlikte al" kartlarındaki hızlı ekle (+) butonu */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-sqw-quick-add]');
  if (!btn) return;
  e.preventDefault();
  const sel = btn.closest('[data-sqw-quick-item]')?.querySelector('select[data-sqw-quick-variant]');
  const id = (sel && sel.value) || btn.dataset.variantId;
  if (!id) return;
  btn.setAttribute('aria-busy', 'true');
  try {
    await add([{ id, quantity: 1 }], { open: btn.dataset.open !== 'false' });
  } catch (err) {
    btn.title = err.message;
  } finally {
    btn.removeAttribute('aria-busy');
  }
});
